export default __webpack_public_path__ + "static/media/fishBackgroundDesktop.5c58f566.png";